import { useCallback } from 'react';

import { Checkbox } from '../../../../../../../../../helpers/Checkbox';

interface ThreeDStockProductsFiltersTypesFilterItemTag {
  id: string;
  label: string;
}

interface ThreeDStockProductsFiltersTypesFilterItemProps {
  tag: ThreeDStockProductsFiltersTypesFilterItemTag;
  onCheckedTag: (tagId: string, checked: boolean) => void;
  checked: boolean;
}

function ThreeDStockProductsFiltersTypesFilterItem({
  onCheckedTag,
  tag,
  checked
}: ThreeDStockProductsFiltersTypesFilterItemProps) {
  const handleCheck = useCallback(
    (checked: boolean) => {
      onCheckedTag(tag.id, checked);
    },
    [onCheckedTag, tag]
  );

  return (
    <li className="py-1">
      <Checkbox
        dataGa={`types-${tag.label}`}
        checkboxWrapperClassName="flex items-center"
        label={tag.label}
        checked={checked}
        onChange={handleCheck}
      />
    </li>
  );
}

export default ThreeDStockProductsFiltersTypesFilterItem;
